module.exports = __webpack_public_path__ + "img/box_stock.68094c41.png";